<div
	*ngIf="visible"
	[ngClass]="[
		'esl-tag',
		removable ? 'removable' : '',
		disabled ? 'disabled' : '',
		forceSmallScreenMode ? 'bigger-font' : '',
		clickable ? 'clickable' : '',
		color ? color : '',
		static ? 'static' : ''
	]"
	[ngStyle]="{
		backgroundColor: static ? color : bgColor,
		color: color || color
	}"
>
	<!-- <mat-icon *ngIf="icon" [fontIcon]="icon" [ngClass]="[icon, 'icon']"></mat-icon> -->
	<i *ngIf="icon" [ngClass]="[icon, 'icon']"></i>
	<span>{{ label }}</span>
	<i
		style="padding-left: 8px; color: red"
		class="times icon"
		*ngIf="removable"
		(click)="remove()"
	></i>
	<!-- <mat-icon *ngIf="removable " fontIcon="close" class="close icon" (click)="remove()"></mat-icon> -->
</div>
